"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EmailFeedbackStatusEnum = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _RegExUtils = require("../../../../../utils/RegExUtils");
var _MeterReadingMailboxInfoPopup = _interopRequireDefault(require("./MeterReadingMailboxInfoPopup"));
var _meterReadingApi = require("../../../../../api-factory/meterReadingApi");
var _MeterReadingEmailFeedbackPropTypes = require("./MeterReadingEmailFeedbackPropTypes");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var EmailFeedbackStatusEnum = exports.EmailFeedbackStatusEnum = /*#__PURE__*/function (EmailFeedbackStatusEnum) {
  EmailFeedbackStatusEnum["ACCEPTED"] = "accepted";
  EmailFeedbackStatusEnum["REFUSED"] = "refused";
  EmailFeedbackStatusEnum["PENDING"] = "pending";
  return EmailFeedbackStatusEnum;
}({});
var CHECKED_SVG_PATH = ['M18 32c7.732 0 14-6.268 14-14S25.732 4 18 4 4 10.268 4 18s6.268 ' + '14 14 14zm0 2C9.163 34 2 26.837 2 18S9.163 2 18 2s16 7.163 16 16-7.163 16-16 16z', 'M16.016 25.872l-8.174-8.196 1.246-1.244 6.931 6.948 10.754-10.754 1.244 1.245-12 12'];
var MeterReadingEmailFeedback = function MeterReadingEmailFeedback(props) {
  var _props$declineButton, _props$declineButton2, _props$acceptButton, _props$acceptButton2;
  var _useState = (0, _react.useState)({
      email: '',
      inputStatus: _reactSharedUiNext.InputState.NONE,
      loading: false,
      serverError: false,
      showMailboxInfoPopup: false
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var buildAcknowledgeText = function buildAcknowledgeText() {
    var str = '';
    if (props.missedMeter === 0) {
      str = "".concat(props.amount, " ").concat(props.metersRegisteredText);
    } else if (props.fromToMetersRegisteredText) {
      str = props.fromToMetersRegisteredText.replace('%%SUCCESS%%', (props.amount - props.missedMeter).toString()).replace('%%TOTAL%%', props.amount.toString());
    }
    return str;
  };
  var checkEmail = function checkEmail(value) {
    var isEmailValid = value ? _RegExUtils.EMAIL_REGEX.test(String(value)) : false;
    setState(_objectSpread(_objectSpread({}, state), {}, {
      email: value,
      serverError: false,
      inputStatus: isEmailValid ? _reactSharedUiNext.InputState.VALID : _reactSharedUiNext.InputState.ERROR
    }));
    return isEmailValid;
  };
  var sendEmail = function sendEmail() {
    var emailObj = JSON.parse(window.sessionStorage.getItem('emailObject') || '{}');
    if (emailObj) {
      emailObj.email = state.email;
      setState(_objectSpread(_objectSpread({}, state), {}, {
        loading: true
      }));
      var result = (0, _meterReadingApi.sendEmailData)(emailObj);
      result.then(function () {
        window.sessionStorage.removeItem('emailObject');
        setState(_objectSpread(_objectSpread({}, state), {}, {
          loading: false,
          serverError: false,
          showMailboxInfoPopup: true
        }));
      });
      result.catch(function () {
        setState(_objectSpread(_objectSpread({}, state), {}, {
          loading: false,
          serverError: true,
          inputStatus: _reactSharedUiNext.InputState.ERROR
        }));
      });
    }
  };
  var errorMessage = state.serverError ? props.serverErrorMessage : props.emailValidationError;
  var acknowledgeTextData = buildAcknowledgeText();
  if (state.loading) {
    return /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Loader, {
      loading: true,
      fallbackGifSrc: sessionStorage.fallbackLoader
    });
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row col-md-12 "
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-email-feedback__success-message"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "meter-reading-email-feedback__success-message__checked-svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: "36",
    height: "36",
    viewBox: "0 0 36 36"
  }, /*#__PURE__*/_react.default.createElement("g", {
    fill: "#0e8803",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "nonzero",
    d: CHECKED_SVG_PATH[0]
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: CHECKED_SVG_PATH[1]
  }))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "meter-reading-email-feedback__success-message"
  }, acknowledgeTextData)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-8 col-md-8 col-sm-offset-2 col-md-offset-2 meter-reading-email-feedback__form-container"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "meter-reading-email-feedback__headline"
  }, props.headLine), /*#__PURE__*/_react.default.createElement("p", {
    className: "meter-reading-email-feedback__description"
  }, props.description), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-email-feedback__form-input"
  }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.TextInput, {
    onBlur: function onBlur(e) {
      checkEmail(e.target.value);
    },
    onChange: function onChange(e) {
      checkEmail(e.target.value);
    },
    id: "meter-reading-email-feedback-input",
    qaId: "meter-reading-email-feedback-input",
    errorMessage: state.inputStatus === _reactSharedUiNext.InputState.ERROR ? errorMessage : '',
    type: "text",
    name: "email",
    value: state.email,
    label: props.emailAddressLabel,
    inputState: state.inputStatus
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-email-feedback__buttons"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Button, {
    className: "meter-reading-email-feedback__buttons__decline",
    version: (_props$declineButton = props.declineButton) === null || _props$declineButton === void 0 ? void 0 : _props$declineButton.version,
    id: "meter-reading-email-feedback-decline-button",
    qaId: "meter-reading-email-feedback-decline-button",
    onClick: function onClick() {
      props.onSuccess(EmailFeedbackStatusEnum.REFUSED, state.email);
    },
    autoFocus: false
  }, ' ', (_props$declineButton2 = props.declineButton) === null || _props$declineButton2 === void 0 ? void 0 : _props$declineButton2.label)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Button, {
    id: "meter-reading-email-feedback-accept-button",
    qaId: "meter-reading-email-feedback-accept-button",
    version: (_props$acceptButton = props.acceptButton) === null || _props$acceptButton === void 0 ? void 0 : _props$acceptButton.version,
    disabled: state.inputStatus !== _reactSharedUiNext.InputState.VALID,
    onClick: function onClick() {
      sendEmail();
    }
  }, ' ', (_props$acceptButton2 = props.acceptButton) === null || _props$acceptButton2 === void 0 ? void 0 : _props$acceptButton2.label)))), /*#__PURE__*/_react.default.createElement(_MeterReadingMailboxInfoPopup.default, (0, _extends2.default)({}, props.mailboxPopup, {
    showPopup: state.showMailboxInfoPopup,
    email: state.email,
    onClose: function onClose() {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        showMailboxInfoPopup: false
      }));
      props.onSuccess(EmailFeedbackStatusEnum.ACCEPTED, state.email);
    }
  })));
};
MeterReadingEmailFeedback.propTypes = _MeterReadingEmailFeedbackPropTypes.meterReadingEmailNotificationPropTypes;
var _default = exports.default = MeterReadingEmailFeedback;